import { render, staticRenderFns } from "./FadeSlide.vue?vue&type=template&id=2fee6c60&"
import script from "./FadeSlide.vue?vue&type=script&lang=js&"
export * from "./FadeSlide.vue?vue&type=script&lang=js&"
import style0 from "./FadeSlide.vue?vue&type=style&index=0&id=2fee6c60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports